import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../slices/authSlice";

export const LogOutBtn = ({ className }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return (
        <button
            {...{className}}
            onClick={() => {
                dispatch(logout());
                navigate('/');
            }}
        >Log Out</button>
    )
}